import angular from 'angular';
import debounce from 'lodash.debounce';

export default class appendToBodyService {
  static get $inject() {
    return ['$timeout', '$document', '$uibPosition'];
  }

  constructor($timeout, $document, $uibPosition) {
    this.$timeout = $timeout;
    this.$document = $document;
    this.$uibPosition = $uibPosition;
  }

  setAppendToBodyCoords(elem, menuElem) {
    const elemOffset = this.$uibPosition.offset(elem);

    menuElem.css({
      left: `${elemOffset.left}px`,
      top: `${elemOffset.top + elemOffset.height}px`,
      width: `${elemOffset.width}px`
    });
  }

  appendToBody(elem, menuElem, callBack) {
    this.$timeout(() => {
      menuElem.addClass('append-body util-invisible util-show');
      angular.element(this.$document.find('body')).append(menuElem);
      this.setAppendToBodyCoords(elem, menuElem);
      const windowElement = angular.element(window);

      windowElement.on('resize', debounce(() => {
        this.setAppendToBodyCoords(elem, menuElem);
      }, 200));
      elem.on('$destroy', () => {
        windowElement.off('resize');
      });

      if (angular.isFunction(callBack)) {
        callBack();
      }

    });

  }
}
